import React, { useState, useEffect } from 'react'
import _ from "lodash"
import { useTranslation } from 'react-i18next'

import FormsList from './formsList'
import TitleWithBtn from 'main_views/components/Titles/TitleWithBtn'

function Forms(props) {

    let { t } = useTranslation()

    let goToBuilder = () => window.open("/form", "_blank") // to avoid scss issues

    return (
        <div className='content'>

            <TitleWithBtn 
                title={t('forms_list')}
                button={{
                    title: t('build_a_new_form'),
                    onClick: goToBuilder
                }}
            />

            <FormsList {...props}/>
            
        </div>
    )
}

export default Forms
